import { repository } from '@/api/base'

export default {
  async getAllSchedule(filters, page = 0) {
    const { data } = await repository.post(`/xlsxSchedule/findAll/${page}`, filters)
    return data
  },

  async getScheduleById(scheduleId){
    const { data } = await repository.get(`/xlsxSchedule/findById?xlsxScheduleId=${scheduleId}`)
    return data
  }
}
